export function staticImageFile(file: string) {
  return `/static/images/${file}`;
}

export function staticCss(file: string) {
  return `/static/css/${file}`;
}
